import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
// Sentry
import * as Sentry from '@sentry/react';
//
import App from './App';
import { registerAppSW } from './pwa';
import { setupPromiseRejectionHandler } from './utils/promise-error-handler';

// ----------------------------------------------------------------------
// Fallback minimal pour Suspense avant le montage du thème MUI.
const MinimalFallback = () => (
  <div
    style={{
      position: 'fixed',
      inset: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#FFFFFF',
    }}
  >
    <style>
      {`
        @keyframes root-loader-spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}
    </style>
    <div
      style={{
        width: 64,
        height: 64,
        borderRadius: 16,
        border: '3px solid rgba(0, 167, 111, 0.16)',
        borderTopColor: '#00A76F',
        animation: 'root-loader-spin 1s linear infinite',
      }}
    />
  </div>
);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement, {
  // Callback called when an error is thrown and not caught by an ErrorBoundary.
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn('Uncaught error', error, errorInfo.componentStack);
  }),
  // Callback called when React catches an error in an ErrorBoundary.
  onCaughtError: Sentry.reactErrorHandler(),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: Sentry.reactErrorHandler(),
});

console.log('');

// Configurer la gestion des rejets de promesses
setupPromiseRejectionHandler({
  onError: (error) => {
    // Logger dans Sentry pour les erreurs de production
    if (process.env.NODE_ENV === 'production') {
      Sentry.captureException(error);
    }
  },
});

root.render(
  <HelmetProvider>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <Suspense fallback={<MinimalFallback />}>
        <App />
      </Suspense>
    </BrowserRouter>
  </HelmetProvider>
);

// Enregistrer le service worker après le rendu
registerAppSW();
